import { useEffect, useRef, useState } from "react";
import { RefreshCw } from "lucide-react";

const THRESHOLD = 70;

/** Mobilde sayfayı aşağı çekip yenileme (yalnız sayfa en üstteyken tetiklenir). */
export const PullToRefresh = ({ children }) => {
  const [pull, setPull] = useState(0);
  const [busy, setBusy] = useState(false);
  const start = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(min-width: 768px)").matches) return undefined;

    const onStart = (e) => {
      if (window.scrollY > 4 || e.touches.length !== 1) return;
      start.current = e.touches[0].clientY;
    };
    const onMove = (e) => {
      if (start.current == null) return;
      const delta = e.touches[0].clientY - start.current;
      if (delta <= 0) {
        setPull(0);
        return;
      }
      setPull(Math.min(delta * 0.5, THRESHOLD + 20));
    };
    const onEnd = () => {
      if (start.current != null && pull >= THRESHOLD) {
        setBusy(true);
        window.setTimeout(() => window.location.reload(), 150);
      }
      start.current = null;
      setPull(0);
    };

    window.addEventListener("touchstart", onStart, { passive: true });
    window.addEventListener("touchmove", onMove, { passive: true });
    window.addEventListener("touchend", onEnd);
    return () => {
      window.removeEventListener("touchstart", onStart);
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("touchend", onEnd);
    };
  }, [pull]);

  return (
    <>
      {(pull > 0 || busy) && (
        <div
          data-testid="pull-to-refresh-indicator"
          style={{ transform: `translateY(${Math.max(pull, busy ? THRESHOLD : 0)}px)` }}
          className="pointer-events-none fixed left-1/2 top-2 z-40 -ml-5 flex h-10 w-10 items-center justify-center rounded-full border border-border bg-card shadow-md md:hidden"
        >
          <RefreshCw
            className={`h-5 w-5 text-primary ${busy ? "animate-spin" : ""}`}
            style={{ transform: busy ? undefined : `rotate(${pull * 3}deg)` }}
          />
        </div>
      )}
      {children}
    </>
  );
};
